export default function useGroupManagement({
  normalizeGroupName,
  findExistingGroupName,
  sortGroupNames,
  DEFAULT_VORLAGEN_GROUPS,
  DEFAULT_BEFUNDBEISPIELE_GROUPS,
  DEFAULT_PROTOKOLLE_GROUPS,
  availableVorlagenGroups,
  availableBefundGroups,
  availableProtokollGroups,
  customVorlagenGroups,
  customBefundGroups,
  customProtokollGroups,
  setCustomVorlagenGroups,
  setCustomBefundGroups,
  setCustomProtokollGroups,
  persistCustomVorlagenGroups,
  persistCustomBefundGroups,
  persistCustomProtokollGroups,
  updateVorlagenGroupOrder,
  updateBefundGroupOrder,
  updateProtokollGroupOrder,
  showStatus,
  newVorlagenGroupName,
  newBefundGroupName,
  newProtokollGroupName,
  setNewPromptMod,
  setNewPromptMrtTarget,
  setExpandedVorlagenGroups,
  setNewVorlagenGroupName,
  setNewPromptSubsection,
  setNewPromptFormOpen,
  setExpandedSections,
  setNewBefundGroupName,
  setNewTplMod,
  setNewSectionMod,
  setNewTplSection,
  setNewSectionName,
  setNewTplFormOpen,
  setExpandedProtokollSections,
  setNewProtokollGroupName,
  setNewProtokollMod,
  setNewProtokollSectionMod,
  setNewProtokollSection,
  setNewProtokollSectionName,
  setNewProtokollFormOpen,
  vorlagenGruppiert,
  isAdmin,
  deleteUserPromptInTable,
  formatSupabaseError,
  vorlagen,
  setVorlagen,
  persistUserVorlagen,
  writeJsonStorage,
  userVorlagenStorageKey,
  newPromptMod,
  supabase,
  tableNames,
  loadAllVorlagen,
  befundbeispiele,
  cloneData,
  setBefundbeispiele,
  persistUserBefundbeispiele,
  newTplMod,
  newSectionMod,
  loadAllBefundbeispiele,
  protokolle,
  setProtokolle,
  persistUserProtokolle,
  newProtokollMod,
  newProtokollSectionMod,
  loadAllProtokolle,
}) {
  const createVorlagenGroup = () => {
    const normalizedName = normalizeGroupName(newVorlagenGroupName);
    if (!normalizedName) {
      showStatus("Bitte Sektionsname eingeben.", true);
      return false;
    }

    const existingName = findExistingGroupName(availableVorlagenGroups, normalizedName);
    const nextGroupName = existingName || normalizedName;

    if (!existingName && !findExistingGroupName(DEFAULT_VORLAGEN_GROUPS, nextGroupName)) {
      const nextGroups = sortGroupNames([...customVorlagenGroups, nextGroupName], DEFAULT_VORLAGEN_GROUPS)
        .filter((group) => !findExistingGroupName(DEFAULT_VORLAGEN_GROUPS, group));
      setCustomVorlagenGroups(nextGroups);
      persistCustomVorlagenGroups(nextGroups);
    }

    if (nextGroupName === "MRT 1,5" || nextGroupName === "MRT 3") {
      setNewPromptMod("MRT");
      setNewPromptMrtTarget(nextGroupName);
    } else {
      setNewPromptMod(nextGroupName);
      setNewPromptMrtTarget("MRT");
    }

    setExpandedVorlagenGroups((prev) => ({
      ...prev,
      [`prompt-group:${nextGroupName}`]: true,
    }));
    updateVorlagenGroupOrder((prev) => [
      ...(prev.length ? prev : availableVorlagenGroups),
      nextGroupName,
    ]);
    setNewVorlagenGroupName("");
    setNewPromptSubsection("");
    setNewPromptFormOpen(true);
    showStatus(`${existingName ? "Sektion gewählt" : "Sektion erstellt"}: "${nextGroupName}" ✓`);
    return true;
  };

  const createBefundGroup = () => {
    const normalizedName = normalizeGroupName(newBefundGroupName);
    if (!normalizedName) {
      showStatus("Bitte Sektionsname eingeben.", true);
      return false;
    }

    const existingName = findExistingGroupName(availableBefundGroups, normalizedName);
    const nextGroupName = existingName || normalizedName;

    if (!existingName && !findExistingGroupName(DEFAULT_BEFUNDBEISPIELE_GROUPS, nextGroupName)) {
      const nextGroups = sortGroupNames([...customBefundGroups, nextGroupName], DEFAULT_BEFUNDBEISPIELE_GROUPS)
        .filter((group) => !findExistingGroupName(DEFAULT_BEFUNDBEISPIELE_GROUPS, group));
      setCustomBefundGroups(nextGroups);
      persistCustomBefundGroups(nextGroups);
    }

    setExpandedSections((prev) => ({
      ...prev,
      [`group:${nextGroupName}`]: true,
    }));
    updateBefundGroupOrder((prev) => [
      ...(prev.length ? prev : availableBefundGroups),
      nextGroupName,
    ]);
    setNewBefundGroupName("");
    setNewTplMod(nextGroupName);
    setNewSectionMod(nextGroupName);
    setNewTplSection("");
    setNewSectionName("");
    setNewTplFormOpen(true);
    showStatus(`${existingName ? "Sektion gewählt" : "Sektion erstellt"}: "${nextGroupName}" ✓`);
    return true;
  };

  const createProtokollGroup = () => {
    const normalizedName = normalizeGroupName(newProtokollGroupName);
    if (!normalizedName) {
      showStatus("Bitte Sektionsname eingeben.", true);
      return false;
    }

    const existingName = findExistingGroupName(availableProtokollGroups, normalizedName);
    const nextGroupName = existingName || normalizedName;

    if (!existingName && !findExistingGroupName(DEFAULT_PROTOKOLLE_GROUPS, nextGroupName)) {
      const nextGroups = sortGroupNames([...customProtokollGroups, nextGroupName], DEFAULT_PROTOKOLLE_GROUPS)
        .filter((group) => !findExistingGroupName(DEFAULT_PROTOKOLLE_GROUPS, group));
      setCustomProtokollGroups(nextGroups);
      persistCustomProtokollGroups(nextGroups);
    }

    setExpandedProtokollSections((prev) => ({
      ...prev,
      [`group:${nextGroupName}`]: true,
    }));
    updateProtokollGroupOrder((prev) => [
      ...(prev.length ? prev : availableProtokollGroups),
      nextGroupName,
    ]);
    setNewProtokollGroupName("");
    setNewProtokollMod(nextGroupName);
    setNewProtokollSectionMod(nextGroupName);
    setNewProtokollSection("");
    setNewProtokollSectionName("");
    setNewProtokollFormOpen(true);
    showStatus(`${existingName ? "Sektion gewählt" : "Sektion erstellt"}: "${nextGroupName}" ✓`);
    return true;
  };

  const deleteVorlagenGroup = async (groupName) => {
    const normalizedGroup = normalizeGroupName(groupName);
    if (!normalizedGroup) return false;

    const entries = vorlagenGruppiert[normalizedGroup] || [];
    const confirmed = window.confirm(
      entries.length > 0
        ? `Sektion "${normalizedGroup}" mit ${entries.length} Vorlage${entries.length === 1 ? "" : "n"} löschen?`
        : `Leere Sektion "${normalizedGroup}" löschen?`
    );
    if (!confirmed) return false;

    const nextCustomGroups = customVorlagenGroups.filter(
      (group) => group.toLowerCase() !== normalizedGroup.toLowerCase()
    );

    if (!isAdmin) {
      const results = await Promise.all(entries.map((entry) => deleteUserPromptInTable(entry.id)));
      const failed = results.find((result) => !result.ok && result.supported);
      if (failed) {
        showStatus(`Fehler beim Löschen: ${formatSupabaseError(failed.error)}`, true);
        return false;
      }

      const ids = new Set(entries.map((entry) => entry.id));
      const nextVorlagen = vorlagen.filter((entry) => !ids.has(entry.id));
      setVorlagen(nextVorlagen);
      setCustomVorlagenGroups(nextCustomGroups);
      persistCustomVorlagenGroups(nextCustomGroups);
      updateVorlagenGroupOrder((prev) => (prev.length ? prev : availableVorlagenGroups).filter((group) => group !== normalizedGroup));

      if (results.some((result) => !result.supported)) {
        await persistUserVorlagen(nextVorlagen);
      } else {
        writeJsonStorage(userVorlagenStorageKey, nextVorlagen);
      }

      setExpandedVorlagenGroups((prev) => {
        const next = { ...prev };
        delete next[`prompt-group:${normalizedGroup}`];
        return next;
      });

      if (newPromptMod === normalizedGroup) {
        setNewPromptMod("CT");
        setNewPromptMrtTarget("MRT");
      }

      showStatus("Sektion gelöscht ✓");
      return true;
    }

    try {
      if (entries.length > 0) {
        const { error } = await supabase.from(tableNames.vorlagen).delete().eq("mod", normalizedGroup);
        if (error) throw error;
      }

      setCustomVorlagenGroups(nextCustomGroups);
      persistCustomVorlagenGroups(nextCustomGroups);
      updateVorlagenGroupOrder((prev) => (prev.length ? prev : availableVorlagenGroups).filter((group) => group !== normalizedGroup));
      setExpandedVorlagenGroups((prev) => {
        const next = { ...prev };
        delete next[`prompt-group:${normalizedGroup}`];
        return next;
      });

      if (newPromptMod === normalizedGroup) {
        setNewPromptMod("CT");
        setNewPromptMrtTarget("MRT");
      }

      await loadAllVorlagen();
      showStatus("Sektion gelöscht ✓");
      return true;
    } catch (err) {
      showStatus(`Fehler beim Löschen: ${formatSupabaseError(err)}`, true);
      return false;
    }
  };

  const deleteBefundGroup = async (groupName) => {
    const normalizedGroup = normalizeGroupName(groupName);
    if (!normalizedGroup) return false;

    const groupSections = befundbeispiele[normalizedGroup] || {};
    const sectionCount = Object.keys(groupSections).length;
    const templateCount = Object.values(groupSections).reduce((sum, list) => sum + list.length, 0);
    const confirmed = window.confirm(
      templateCount > 0
        ? `Sektion "${normalizedGroup}" mit ${templateCount} Befundbeispiel${templateCount === 1 ? "" : "en"} in ${sectionCount} Untersektion${sectionCount === 1 ? "" : "en"} löschen?`
        : `Leere Sektion "${normalizedGroup}" löschen?`
    );
    if (!confirmed) return false;

    const nextCustomGroups = customBefundGroups.filter(
      (group) => group.toLowerCase() !== normalizedGroup.toLowerCase()
    );

    if (!isAdmin) {
      const nextBefundbeispiele = cloneData(befundbeispiele);
      delete nextBefundbeispiele[normalizedGroup];

      setBefundbeispiele(nextBefundbeispiele);
      persistUserBefundbeispiele(nextBefundbeispiele);
      setCustomBefundGroups(nextCustomGroups);
      persistCustomBefundGroups(nextCustomGroups);
      updateBefundGroupOrder((prev) => (prev.length ? prev : availableBefundGroups).filter((group) => group !== normalizedGroup));
      setExpandedSections((prev) => {
        const next = { ...prev };
        delete next[`group:${normalizedGroup}`];
        return next;
      });

      if (newTplMod === normalizedGroup) setNewTplMod("CT");
      if (newSectionMod === normalizedGroup) setNewSectionMod("CT");

      showStatus("Sektion gelöscht ✓");
      return true;
    }

    try {
      if (templateCount > 0) {
        const { error } = await supabase.from(tableNames.befundbeispiele).delete().eq("mod_group", normalizedGroup);
        if (error) throw error;
      }

      setCustomBefundGroups(nextCustomGroups);
      persistCustomBefundGroups(nextCustomGroups);
      updateBefundGroupOrder((prev) => (prev.length ? prev : availableBefundGroups).filter((group) => group !== normalizedGroup));
      setExpandedSections((prev) => {
        const next = { ...prev };
        delete next[`group:${normalizedGroup}`];
        return next;
      });

      if (newTplMod === normalizedGroup) setNewTplMod("CT");
      if (newSectionMod === normalizedGroup) setNewSectionMod("CT");

      await loadAllBefundbeispiele();
      showStatus("Sektion gelöscht ✓");
      return true;
    } catch (err) {
      showStatus(`Fehler beim Löschen: ${formatSupabaseError(err)}`, true);
      return false;
    }
  };

  const deleteProtokollGroup = async (groupName) => {
    const normalizedGroup = normalizeGroupName(groupName);
    if (!normalizedGroup) return false;

    const groupSections = protokolle[normalizedGroup] || {};
    const sectionCount = Object.keys(groupSections).length;
    const templateCount = Object.values(groupSections).reduce((sum, list) => sum + list.length, 0);
    const confirmed = window.confirm(
      templateCount > 0
        ? `Sektion "${normalizedGroup}" mit ${templateCount} Protokoll${templateCount === 1 ? "" : "e"} in ${sectionCount} Untersektion${sectionCount === 1 ? "" : "en"} löschen?`
        : `Leere Sektion "${normalizedGroup}" löschen?`
    );
    if (!confirmed) return false;

    const nextCustomGroups = customProtokollGroups.filter(
      (group) => group.toLowerCase() !== normalizedGroup.toLowerCase()
    );

    if (!isAdmin) {
      const nextProtokolle = cloneData(protokolle);
      delete nextProtokolle[normalizedGroup];

      setProtokolle(nextProtokolle);
      persistUserProtokolle(nextProtokolle);
      setCustomProtokollGroups(nextCustomGroups);
      persistCustomProtokollGroups(nextCustomGroups);
      updateProtokollGroupOrder((prev) => (prev.length ? prev : availableProtokollGroups).filter((group) => group !== normalizedGroup));
      setExpandedProtokollSections((prev) => {
        const next = { ...prev };
        delete next[`group:${normalizedGroup}`];
        return next;
      });

      if (newProtokollMod === normalizedGroup) setNewProtokollMod("CT");
      if (newProtokollSectionMod === normalizedGroup) setNewProtokollSectionMod("CT");

      showStatus("Sektion gelöscht ✓");
      return true;
    }

    try {
      if (templateCount > 0) {
        const { error } = await supabase.from(tableNames.protokolle).delete().eq("mod_group", normalizedGroup);
        if (error) throw error;
      }

      setCustomProtokollGroups(nextCustomGroups);
      persistCustomProtokollGroups(nextCustomGroups);
      updateProtokollGroupOrder((prev) => (prev.length ? prev : availableProtokollGroups).filter((group) => group !== normalizedGroup));
      setExpandedProtokollSections((prev) => {
        const next = { ...prev };
        delete next[`group:${normalizedGroup}`];
        return next;
      });

      if (newProtokollMod === normalizedGroup) setNewProtokollMod("CT");
      if (newProtokollSectionMod === normalizedGroup) setNewProtokollSectionMod("CT");

      await loadAllProtokolle();
      showStatus("Sektion gelöscht ✓");
      return true;
    } catch (err) {
      showStatus(`Fehler beim Löschen: ${formatSupabaseError(err)}`, true);
      return false;
    }
  };

  return {
    createVorlagenGroup,
    createBefundGroup,
    createProtokollGroup,
    deleteVorlagenGroup,
    deleteBefundGroup,
    deleteProtokollGroup,
  };
}
